import $ from 'jquery';
import * as variables from 'variables';

export default function loadBannerNewsSchedule(cb) {
	if (!variables.bannerNewsSchedule) {
		$.getJSON(`/Umbraco/Api/BannerApi/GetBannerDirectio?id=${__globalJsData.currentPageId}`).done((data) => {
			// variables.bannerNewsSchedule = data;
			cb(null, data);
		}).fail((jqXHR, textStatus, errorThrown) => {
			// variables.bannerNewsSchedule = data;
			cb(errorThrown);
		});
	}
	cb(null, variables.bannerNewsSchedule);
}



/** WEBPACK FOOTER **
 ** ./Scripts/libs/utils/loadBannerNewsSchedule.js
 **/